<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-16 15:33:33
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-19 13:23:14
 * @Description: file content
 -->
<template>
  <div class="btn_backhome">
    <BtnBackLayout4 v-if="isShowBack"></BtnBackLayout4>
    <BtnHomeLayout4 v-if="isShowHome"></BtnHomeLayout4>
  </div>
</template>

<script>
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
const BtnHomeLayout4 = () => import("@/components/btn_home_layout4");

export default {
  components: {
    BtnBackLayout4,
    BtnHomeLayout4
  },
  props: {},
  data() {
    return {
      isShowBack: false,
      isShowHome: false
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    // backhome=back，展示返回按钮
    // backhome=home，
    if (this.$route.query.backhome == "back") {
      this.isShowBack = true;
    }
    if (this.$route.query.backhome == "home") {
      this.isShowHome = true;
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.btn_backhome {
}
</style>